export const url = (imageData) => {
  const src = typeof imageData.src === 'object' ? imageData.src.src ?? imageData.url.src : imageData.src;
  const output = new URL(src, `https://${Shopify.cdnHost}`);

  output.searchParams.append('width', '{width}');
  output.searchParams.append('height', '{height}');
  output.searchParams.append('crop', 'center');

  return decodeURI(output.toString());
};

export const image = (imageData, className, aspect = imageData.width / imageData.height) => `
  <img
    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    data-src="${url(imageData)}"
    data-aspectratio="${aspect}"
    data-sizes="auto"
    data-max-width="${imageData.width}"
    data-max-height="${imageData.height}"
    alt="${imageData.alt ?? ''}"
    class="lazyload ${className}"
    decoding="async"
  >
`;

export default {
  image,
  url,
};
